import createNlxStuProject from "./projects/nlx_stu/index"

export default function () {
    createNlxStuProject()
}